import { useEffect, useState } from 'react';

import type { FileMenuItemFieldsFragment } from '@/gql/graphql';

import { FilePicker } from './file-picker';

import type { FilePickerProps } from './file-picker/FilePicker';

interface Props extends Omit<
  FilePickerProps,
  'selectionMode' | 'parentId' | 'onChangeParent'
> {
  startingParentId?: string | null | undefined;
  open: boolean;
}

export const FolderSelector = ({
  startingParentId,
  disableItemWithReason: disableItemWithReasonProp,
  open,
  ...other
}: Props) => {
  const [parentId, setParentId] = useState<string | null | undefined>(
    startingParentId,
  );

  useEffect(() => {
    if (!open) {
      return;
    }

    setParentId(startingParentId);
  }, [open, startingParentId]);

  const disableItemWithReason = (file: FileMenuItemFieldsFragment) => {
    if (!file.folder) {
      return `Can only select folders`;
    }

    if (disableItemWithReasonProp) {
      return disableItemWithReasonProp(file);
    }
  };

  return (
    <FilePicker
      selectionMode="folder"
      parentId={parentId}
      open={open}
      onChangeParent={setParentId}
      disableItemWithReason={disableItemWithReason}
      {...other}
    />
  );
};
